import api from "./api";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import { resources } from "./resources";

class ModeloFatura {
    private _baseUrl: string;

    constructor() {
        this._baseUrl = resources.modeloFatura.toLowerCase();
    }

    async getModelosWithFilter(filters: any) {
        return await api.get<IPayload>(`${this._baseUrl}/filter/${ToQueryString({ ...filters })}`);
    }

    async getAllModelos() {
        return await api.get(`${this._baseUrl}`);
    }

    async downloadModelo(id: any, tipoDownload: string, arquivoTipo: string) {
        const response = await api.get(`${this._baseUrl}/download`, {
            params: {
                idModelo: id,
                tipoDownload,
            },
            responseType: "blob",
        });

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");

        link.href = url;
        link.setAttribute("download", tipoDownload === "C" ? `Fatura_${id}.${arquivoTipo}` : `Fatura_${id}.csv`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    }

    async replicarModelo(data: any) {
        return await api.post(`${this._baseUrl}/replica/`, data);
    }

    async createModelo(data: any) {
        return await api.post<any>(`${this._baseUrl}`, data);
    }

    async updateModelo(data: any) {
        return await api.put<any>(`${this._baseUrl}`, data);
    }

    async deleteModelo(id: any) {
        return await api.delete<any>(`${this._baseUrl}`, { data: { modeloFaturaId: id } });
    }

    async getAtributosWithFilter(filters: any) {
        return await api.get<IPayload>(`${this._baseUrl}/atributo/filter/${ToQueryString({ ...filters })}`);
    }

    async getAllCampos() {
        return await api.get(`${this._baseUrl}/atributo`);
    }

    async createAtributo(data: any) {
        return await api.post<any>(`${this._baseUrl}/atributo`, data);
    }

    async updateAtributo(data: any) {
        return await api.put<any>(`${this._baseUrl}/atributo`, data);
    }

    async deleteAtributo(id: any) {
        return await api.delete<any>(`${this._baseUrl}/atributo/${id}`);
    }

    async getPosicoesWithFilter(filters: any) {
        return await api.get<IPayload>(`${this._baseUrl}/posicao/${ToQueryString({ ...filters })}`);
    }

    async createPosicao(data: any) {
        return await api.post<any>(`${this._baseUrl}/posicao`, data);
    }

    async updatePosicao(data: any) {
        return await api.put<any>(`${this._baseUrl}/posicao`, data);
    }

    async deletePosicao(id: any) {
        return await api.delete<any>(`${this._baseUrl}/posicao/${id}`);
    }
}

export default new ModeloFatura();
